import styled from '@emotion/styled';

import vars from 'theme/styles/vars';

export default styled.section`
	width: 100%;

	.register-form {
		width: 80%;

		.title {
			margin: 0 0 1em 0;
			font-weight: 500;

			&-margin {
				margin: 1em 0;
			}
		}

		.layout-forms-input {
			&.name-phone {
				margin-bottom: 1em;
			}
		}

		.layout-forms-checkbox {
			.label {
				color: #666666;
				font-size: .8em;

				a {
					color: #666666;
					text-decoration: underline;
				}
			}
		}

		.disclaimer {
			color: #666666;
			font-size: .7em;

			a {
				color: #666666;
				text-decoration: underline;
			}
		}

		.submit-button {
			margin: 2em 0;
			justify-content: flex-start;
		}

		.google-binded {
			margin: 1em 0 1.5em 0;

			.headline {
				margin: 0 0 1em 0;
				font-weight: 500;
				font-size: 1em;
			}

			.details {
				display: flex;
				flex-flow: row wrap;
				place-items: center;
				gap: 1em;
				border: 0.02em solid ${vars.colorPrimaryDark};
				padding: 1em;
				border-radius: ${vars.defaultRadius};

				.details-image {
					border-radius: ${vars.defaultRadius};
				}

				.image-icon {
					margin-left: auto;
				}

				.details-user {
					display: flex;
					flex-flow: column wrap;
					gap: 0.3em;
					font-size: 0.8em;

					.details-user-name {
						font-weight: 500;
					}
				}
			}
		}
	}

	@media all and (max-width: ${vars.tabletL}) {
		.register-form {
			.title {
				font-size: 1.3em;
			}
		}
	}
`;
